import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol viewBox=\"0 0 23 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hamburger\">\n<rect x=\"0.5\" y=\"0.5\" width=\"22\" height=\"22\" rx=\"2.5\" fill=\"white\" stroke=\"#EAEBEE\" />\n<path d=\"M11 14.9995L8 11.9995L11 8.99951\" stroke=\"#671E75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M15 14.9995L12 11.9995L15 8.99951\" stroke=\"#671E75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol